import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getUnpaidWorks = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/unpaid_work`
    );
  }
  return http.get(
    `${getBaseUrl()}/unpaid_work?${paginate}`
  );
};